import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react';
import { Button } from '@mui/material';
import { styled } from '@mui/system';
import { isEmpty } from 'lodash';

import './scss/index.scss';
import Color from '@tool/color';
import IndustryCompare from './industry-compare/index';
import TimeTrend from './time-trend';
import FeeRate from './fee-rate';
import Title from '../component/title';
import Indicators from '../component/indicators';
import moSkin from '@store/skin';
import moUser from '@store/user';
import moStore, { toggleValue } from '@store/index';
import moEffect from '../store/index';
import moCost, { costInit } from './store/index';

interface IProps {}
interface IState {}

const SalaryCost = (props: IProps, state: IState) => {
  const navi = useNavigate();
  const [salaryOpen, setSalaryOpen] = useState(false);
  const salaryList = [
    '1.薪酬成本 = 当年应付职工薪酬 + 支付给职工以及为职工支付的现金 - 上一年应付职工薪酬',
    '2. 研发类员工的薪酬 = 研发类员工的工资性收入',
    '3. 销售类员工的薪酬 = 销售类员工的工资性收入',
    '4. 管理类员工的薪酬 = 管理类员工的工资性收入',
  ];

  useEffect(() => {
    const show = localStorage.getItem('showIndicator');
    if (show === 'false') setSalaryOpen(false);
    else setSalaryOpen(true);

    return () => {};
  }, []);

  const onOpenSalary = () => {
    setSalaryOpen(true);
  };

  const onCloseSalary = () => {
    setSalaryOpen(false);
  };

  return (
    <section className="salary-cost_10">
      <Title title="薪酬成本投入" subtitle="薪酬成本投入" onIndi={onOpenSalary} />
      {salaryOpen && <Indicators onClose={onCloseSalary}
        calculate="占比变化 = 当年占比 - 上一年占比" list={salaryList} />}
      <IndustryCompare />
      <TimeTrend />
      <FeeRate />
    </section>
  );
};

export default observer(SalaryCost);
